import { ReactiveVue } from "@skinsoft/reactive-vue";
import Component from "vue-class-component";
import { DeleteImageClickEvent, ImageClickEvent, MediaArea } from '@skinsoft/entity/src/media/medias-area';
import { Alteration } from '@skinsoft/entity';
import { DELETE_IMAGE_CLICK_TOPIC, IMAGE_CLICK_TOPIC, IMAGE_UPLOADED_TOPIC, MEDIA_END_LOADING_TOPIC, MEDIA_ID_CHANGED_FROM_CACHE, PRINCIPAL_IMAGE_CLICK_TOPIC } from '@skinsoft/bus/src/busTopics';
import { ImageTransferHelper, MediaTransferHelper } from '@skinsoft/media-transfer-helper';
import { Watch } from 'vue-property-decorator';
import { OPEN_DRAWING_EDITOR_TOPIC } from "../../../busTopics";

@Component({
    components: {
        sMediaArea: MediaArea
    },
    props: ['associatedMedias', 'alterations'],
    template: require('./condition-report-medias-area.html')
})
export default class ConditionReportMediasArea extends ReactiveVue {
    private associatedMedias: string[]
    private alterations: Alteration[]

    private mediasToDisplay: string[] = []
    private mediaUploadInProgress: boolean = false;
    private clickOnMediasAllowed: boolean = true

    private $imageTransferHelper: ImageTransferHelper

    private DELETE_IMAGE_CLICK_TOPIC = DELETE_IMAGE_CLICK_TOPIC
    private IMAGE_UPLOADED_TOPIC = IMAGE_UPLOADED_TOPIC
    private PRINCIPAL_IMAGE_CLICK_TOPIC = PRINCIPAL_IMAGE_CLICK_TOPIC
    private MEDIA_ID_CHANGED_FROM_CACHE = MEDIA_ID_CHANGED_FROM_CACHE
    private IMAGE_CLICK_TOPIC = IMAGE_CLICK_TOPIC

    public mounted() {
        this.computeMediasToDisplay()
        this.subscribeToBus(MEDIA_END_LOADING_TOPIC, (message => {
                this.clickOnMediasAllowed = true
        }))
    }

    public computeMediasToDisplay() {
        if(this.associatedMedias) {
            // we only add medias that are not present in the array to avoid changing position of the newly added medias in the array
            // this can occur because we notify the parent that a new media has been uploaded only after having uploaded it on server
            const newMedias = this.associatedMedias.filter(mediaId => !this.mediasToDisplay.includes(mediaId))
            this.mediasToDisplay = this.mediasToDisplay.concat(newMedias)
        }

        return []
    }

    private onImageClick(event: ImageClickEvent) {
        if(this.clickOnMediasAllowed) {
            this.emitOnBus(OPEN_DRAWING_EDITOR_TOPIC, event.id)
        }
    }

    private onImageDeleteClick(event: DeleteImageClickEvent) {
        if (this.mediasToDisplay) {
            const removedMediaId = this.mediasToDisplay.splice(event.imageListIndex, 1)
            event.imageId = removedMediaId[0]
        }
        this.$emit(DELETE_IMAGE_CLICK_TOPIC, event)
    }

    private async uploadMedia(fileData) {
        this.clickOnMediasAllowed = false
        const formData = new FormData()
        formData.append("file", fileData.file)

        this.mediaUploadInProgress = true
        // Retrieving temp id and uploading the media on backend asynchronously
        let cacheKey = ''
        if(window.navigator.onLine) {
            cacheKey = this.$imageTransferHelper.uploadImage(fileData.file.type, fileData.file, fileData.url)
        }
        else {
            cacheKey = this.$imageTransferHelper.uploadImageInCache(fileData.file, fileData.url)
        }
        this.mediaUploadInProgress = false

        this.mediasToDisplay.push(cacheKey)

        if(window.navigator.onLine) {
            const fileName = cacheKey.split(':')
            if(fileName) {
                const newMedia = await MediaTransferHelper.getInstance().repeatFindingMediaIdFromFileName(cacheKey.split(':')[1])
                
                // updating id in local list (to avoid media changing position in array)
                let mediaIndex = this.mediasToDisplay.indexOf(cacheKey)
                this.mediasToDisplay[mediaIndex] = newMedia.id
                
                this.$imageTransferHelper.addImageToReporterSubAlbum(newMedia.id)
                this.$emit('addMedia', {cacheKey: cacheKey, newMediaId: newMedia.id})
                return
            }
        }

        this.$emit('addMedia', { cacheKey: cacheKey })
    }

    @Watch('associatedMedias', { deep: true })
    public onAssociatedMediasChange() {
        this.computeMediasToDisplay()
    }

    @Watch('alteration', { deep: true })
    public onAlterationChange() {
        this.computeMediasToDisplay()
    }
}